import request from 'superagent'

function getCookie (name) {
  if (!name) return null
  return decodeURIComponent(
    document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
    encodeURIComponent(name).replace(/[-.+*]/g, '\\$&') +
    '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null
}

const CSRFToken = getCookie('csrftoken')

const actions = {
  getCandidates: (page, cb) => {
    request
      .get(`/app/candidates/?page=${page}`)
      .set('X-CSRFToken', CSRFToken)
      .accept('json')
      .end(cb)
  },
  createCandidate: (data, cb) => {
    request
      .post('/app/candidates/')
      .set('X-CSRFToken', CSRFToken)
      .accept('json')
      .send(data)
      .end(cb)
  }
}

export default actions
